import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {RemarkListAPI} from "./../../API/Caller/RemarkAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";


const Remarks = () =>{

    const [remarks, setRemarks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    
    const perpagedata = 20;


    useEffect(() => {

        RemarkListAPI(setRemarks, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Remarks</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive custom-table">
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Lead Name</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Remarks</th>
                                                <th scope="col">Remark Date</th>
                                                {/*<th scope="col">Caller Name</th>
                                                <th className="text-end">Action</th>*/}
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="4">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (remarks && remarks.length > 0  ? 
                                                ( remarks.map(remark => 
                                                    (
                                            
                                                        <tr key={remark.id}>
                                                            <td>{remark.leaddata.name}</td>
                                                            <td>{remark.leaddata.email}</td>
                                                            <td>{remark.remarks}</td>
                                                            <td>
                                                                {(remark.created_at !== "" && remark.created_at !== null) ?
                                                                    (moment(remark.created_at).format('DD MMMM, YYYY'))
                                                                :
                                                                    <>-</>
                                                                }
                                                            </td>
                                                            {/*<td>
                                                                {remark.userdata ?
                                                                    (remark.userdata.name )
                                                                :
                                                                    <p>-</p>
                                                                }
                                                            </td>
                                                            <td className="text-end">
                                                                <Link to="" class="btn btn-dark btn-sm">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" class="btn btn-danger btn-sm">
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>*/}
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="4">
                                                        <center><p>No record found...</p></center>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default Remarks;